var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.emoji)?_c('div',[_vm._v(" "+_vm._s(_vm.emojies[_vm.language])+" ")]):_c('img',{attrs:{"src":_vm.flagPath}})])
}
var staticRenderFns = []

export { render, staticRenderFns }